<template>
    <!-- footer section -->
    <footer>
        <div class="bg-dark text-center p-5 mt-5">
            <div class="row">
                <div class="text-light">
                    <p>
                        Copyright © <a href="/">Shoppy</a> | Created by <a href="https://github.com/maungbo404"
                            target="_blank">Bo Bo Aung</a>
                    </p>
                </div>
            </div>

        </div>
    </footer>
    <!-- footer section -->
</template>
<script>

</script>
<style>
footer {
    clear: both;
    /* position: relative; */
    /* height: 200px; */
    margin-top: 200px;
}
</style>